var exports = {
  "w5": "headerRegion__itTtan",
  "XV": "topBar__8P_VdK",
  "_o": "topBarActions__ls3EmZ",
  "N1": "headerContainer__MoQpha",
  "y9": "headerContainer_stickyHeader__lLBq-w",
  "Jc": "minimalHeader__cMT-zx",
  "FB": "PageHeader_TitleArea__bZM3Nm",
  "ok": "PageHeader_Title__h1a4sE",
  "Ng": "PageHeader_Title_stickyHeader__yA4O0P",
  "V_": "PageHeader_Title_viewport__Hk8eok",
  "Y0": "PageHeader_Title_container__NR1-fF",
  "Vi": "PageHeader_Title_marginRight__RB_Qdt",
  "al": "issueTitle__zprx8E",
  "T3": "issueTitle_marginRight__3uiI0Q",
  "Ci": "issueNumberContainer__lNx8xa",
  "Hv": "issueNumberLink__xH9E6V",
  "uZ": "issueNumberText__ZPJKLj",
  "n1": "editTitleButton__PB25DK",
  "nF": "PageHeader_ContextAreaActions__SeBV-R",
  "E_": "PageHeader_ContextArea__nxSJ5F",
  "JU": "desktopMetadataContainer__1_5fuM",
  "XG": "metadataWrapper__mAHLtf",
  "B1": "PageHeader_Actions__zkcrVC",
  "Im": "PageHeader_Actions_viewport__Z5e1u6",
  "bi": "PageHeader_Actions_container__U30GcK",
};

module.exports = exports;
